module.exports = __webpack_public_path__ + "img/loginBg.d5a83fd0.png";